module.exports = __webpack_public_path__ + "img/provider1.e60207e1.png";